import { useAtomValue } from "jotai";
import { useQuery } from "@tanstack/react-query";
import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";
import TenantAPI from "../../api/TenantAPI";
import { getErrorMessage, groupTagData } from "../../../utils/GeneralUtils";

/**
 * useTags - Hook to get tags for a scope. Uses react-query to cache results.
 * @param {string} scope - The scope to get tags for.
 *  */
const useTags = (scope: {
  Type: string;
  WorkspaceID?: string;
  ModuleAPIName?: string;
  PersonID?: string;
}) => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);

  const tags = useQuery({
    queryKey: ["tags", scope],
    queryFn: () =>
      TenantAPI.getTags(scope).then((data) => {
        return {
          tags: data.data.data.tags,
          tagGroups: groupTagData(data.data.data.tags),
        };
      }),

    enabled: queriesEnabled,
    staleTime: Infinity,
  });

  return {
    tags: tags.data?.tags,
    tagGroups: tags.data?.tagGroups,
    tagsLoading: tags.isLoading,
    tagsError: tags.error ? getErrorMessage(tags.error) : null,
  };
};

export default useTags;
